/**
 * ts-main-style FloatingNav for fleet-doctor.
 * Bottom navigation pill with key module shortcuts.
 * Uses lucide-react icons matching ts-main's design.
 */
import { useNavigate, useLocation } from 'react-router-dom'
import {
  LayoutDashboard,
  Ship,
  Wrench,
  Users,
  ShieldCheck,
  Building2, Wallet
} from 'lucide-react'

interface NavItem {
  path: string
  icon: typeof LayoutDashboard
  label: string
  activePrefix?: string
}

const NAV_ITEMS: NavItem[] = [
  { path: '/dashboard', icon: LayoutDashboard, label: 'Home' },
  { path: '/manage/dashboard', icon: Building2, label: 'Admin', activePrefix: '/manage' },
  { path: '/operations/dashboard', icon: Ship, label: 'Ops', activePrefix: '/operations' },
  { path: '/technical/pms/dashboard', icon: Wrench, label: 'Tech', activePrefix: '/technical' },
  { path: '/crewing/dashboard', icon: Users, label: 'Crew', activePrefix: '/crewing' },
  { path: '/qhse/dashboard', icon: ShieldCheck, label: 'QHSE', activePrefix: '/qhse' },
  { path: '/accounts', icon: Wallet, label: 'Accounts' },
]

export default function FloatingNav() {
  const navigate = useNavigate()
  const location = useLocation()

  // Determine which nav item is active based on current path prefix
  const getIsActive = (path: string): boolean => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard' || location.pathname.startsWith('/dashboard/')
    }
    return location.pathname.startsWith(path)
  }

  // Hide floating nav during create or edit of anything in sales and purchases
  const pathParts = location.pathname.split('/').filter(Boolean)
  if (pathParts[0] === 'accounts' && (pathParts[1] === 'sales' || pathParts[1] === 'purchase') && pathParts.length > 3) {
    return null
  }

  return (
    <nav className="floating-nav" id="floating-nav">
      {NAV_ITEMS.map(({ path, icon: Icon, label, activePrefix }) => (
        <button
          key={path}
          type="button"
          onClick={() => navigate(path)}
          className={activePrefix ? (location.pathname.startsWith(activePrefix) ? 'active' : '') : getIsActive(path) ? 'active' : ''}
        >
          <Icon />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  )
}
